import { render, staticRenderFns } from "./AddActivityGuidancePage.vue?vue&type=template&id=55228fc5&"
import script from "./AddActivityGuidancePage.vue?vue&type=script&lang=js&"
export * from "./AddActivityGuidancePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports